import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../scss/style.scss";

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
	// Find all form containers (they now have unique IDs starting with 'form-root-')
	const containers = document.querySelectorAll("[id^='form-root-']");

	if (!containers.length) {
		console.log("No form containers found");
		return;
	}

	containers.forEach((container) => {
		const formId = container.id;
		const configKey = "form_config_" + formId;

		// Check if this form has its configuration
		if (window[configKey]) {
			const root = createRoot(container);
			root.render(<App config={window[configKey]} />);
		} else {
			console.error("No configuration found for form:", formId);
		}
	});
});
